import { render } from "./HeaderName.vue?vue&type=template&id=064067c7&scoped=true&ts=true"
import script from "./HeaderName.vue?vue&type=script&lang=ts"
export * from "./HeaderName.vue?vue&type=script&lang=ts"

import "./HeaderName.vue?vue&type=style&index=0&id=064067c7&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064067c7"]])

export default __exports__